<template>
  <el-dialog
    :title="'评审文件一览'"
    :close-on-click-modal="false"
    class="abow_dialog"
    width="60%"
    :visible.sync="visible">

    <el-table
      :data="tableData"
      :header-cell-style="{background:'#f5f5f5'}"
      border
      style="width: 100%">

      <el-table-column
        prop="originalName"
        header-align="center"
        align="left" 
        label="文件名称">
      </el-table-column>

      <el-table-column
        prop="fileDesc"
        header-align="center" 
        align="left" 
        label="文件描述">
      </el-table-column>

      <el-table-column
        prop="fileSize"
        header-align="center" 
        align="right" 
        label="文件大小">
      </el-table-column>

      <el-table-column
        prop="createTime"
        header-align="center" 
        align="right" 
        label="上传时间">
      </el-table-column>

      <el-table-column
                prop="fileUrl"
                header-align="center"
                align="center"
                width="120"
                label="评审附件">
            <template slot-scope="scope">
                <el-button icon="el-icon-view" type="text"  @click="viewHandle(scope.row)">查看</el-button>
            </template>
        </el-table-column>

      </el-table>
  </el-dialog>
</template>

<script>
  import {selectFileList,getFileURL} from '@/controller/supplier'
  import {getUrl} from '@/controller/sys'
  
  export default {
    data () {
      
      return {
        visible: false,
        initValue: {
        },
        // 主要用于存储和页面显示相关的数据以及状态
        view: {
        },
        // 用于存储form 中的数据
        dataForm: [],
        dataRule: {
          
        },
        bizType:0,
        bizFid:0,

        tableData: []
      }
    },
    methods: {
      init (row) {
        this.visible = true
        this.$nextTick(() => {
            selectFileList({
                    'bizFid': row.targetId,
                    'bizType': row.applyformType
                }).then(data => {
                    if (data && data.code === '00') {
                        this.tableData = data.body
                    } else {
                        this.tableData = []
                    }

                })
        })
      },

      getFile(id){
          getFileURL({
                    'id': id
                }).then(data => {
                    if (data && data.code === '00') {
                        this.tableData = data.body
                    } else {
                        this.tableData = []
                    }

                })
      },

      // 文件下载
      viewHandle(row){
                getUrl({
                    'fileId': row.id
                }).then(data => {
                    if (data && data.code === '00' && data.body) {
                        // location.href=data.body; 
                        this.download(data.body, row.originalName)
                    } else {
                        this.tableData = []
                    }
                })
            },

            getBlob(url, cb) {
              var xhr = new XMLHttpRequest();
              xhr.open("GET", url, true);
              xhr.responseType = "blob";
              xhr.onload = function() {
                if (xhr.status === 200) {
                  cb(xhr.response);
                }
              };
              xhr.send();
            },
            saveAs(blob, filename) {
              if (window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, filename);
              } else {
                var link = document.createElement("a");
                var body = document.querySelector("body");

                link.href = window.URL.createObjectURL(blob);
                link.download = filename;

                // fix Firefox
                link.style.display = "none";
                body.appendChild(link);

                link.click();
                body.removeChild(link);

                window.URL.revokeObjectURL(link.href);
              }
            },
            download(url, filename) {
              const _this = this
              this.getBlob(url, function(blob) {
                _this.saveAs(blob, filename);
              });
            }

    }
  }
</script>
<style lang="scss">
  .el-dialog__body{
    .user-info-dialog-form{
      width: 95%;
      .el-select{
        width: 222px;
      }
    }
  }
</style>